import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaTelegram } from 'react-icons/fa';
import SponsorCard from '../components/SponsorCard';
import SponsorLogoMarquee from '../components/SponsorLogoMarquee';

const SponsorsPage = () => {
  const [sections, setSections] = useState([]);
  const [allSponsors, setAllSponsors] = useState([]);
  const [sponsorBanners, setSponsorBanners] = useState([]);
  const [gridSponsors, setGridSponsors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [sectionsRes, sponsorsRes, bannersRes] = await Promise.all([
          axios.get('/api/sections?page=sponsors'),
          axios.get('/api/sponsors'),
          axios.get('/api/sponsor-banners')
        ]);

        setSections(sectionsRes.data);
        setAllSponsors(sponsorsRes.data);
        setSponsorBanners(bannersRes.data || []);

        // Set grid sponsors (exclude only ad cards, include all sizes)
        setGridSponsors(sponsorsRes.data.filter(s =>
          !(s.is_ad_card === 1 || s.is_ad_card === true || s.tier === 'reklam-alani')
        ));
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-dark">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-gold"></div>
      </div>
    );
  }

  return (
    <div className="w-full overflow-x-hidden">
      {/* Sponsor Logo Marquee - Sticky at top */}
      <SponsorLogoMarquee sponsors={allSponsors} />

      {/* Page Content */}
      <div className="w-full px-3 sm:px-4 py-4 sm:py-6 md:py-8 lg:py-12 relative">
        {/* Telegram Link - Left Side (Desktop) */}
        <div className="fixed left-4 top-1/2 transform -translate-y-1/2 z-40 hidden lg:block">
          <a
            href="https://t.me/saguexsohbet"
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center gap-2 bg-navy-900/90 border-2 border-gold/30 rounded-lg p-3 hover:border-gold hover:bg-navy-800/90 transition-all duration-300 shadow-lg hover:shadow-gold/50 group"
          >
            <FaTelegram className="w-6 h-6 text-gold group-hover:scale-110 transition-transform" />
            <span className="text-xs text-white/80 group-hover:text-gold transition-colors text-center whitespace-nowrap">Telegram</span>
          </a>
        </div>

        {/* Reklam Ver Link - Right Side (Desktop) */}
        <div className="fixed right-4 top-1/2 transform -translate-y-1/2 z-40 hidden lg:block">
          <a
            href="https://t.me/SaguexMarketing"
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center gap-2 bg-navy-900/90 border-2 border-gold/30 rounded-lg p-3 hover:border-gold hover:bg-navy-800/90 transition-all duration-300 shadow-lg hover:shadow-gold/50 group"
          >
            <FaTelegram className="w-6 h-6 text-gold group-hover:scale-110 transition-transform" />
            <span className="text-xs text-white/80 group-hover:text-gold transition-colors text-center whitespace-nowrap">Reklam Ver</span>
          </a>
        </div>

        {/* Mobile Telegram Links - Top of page */}
        <div className="lg:hidden flex justify-center gap-4 mb-4 pb-4 border-b border-gold/20">
          <a
            href="https://t.me/saguexsohbet"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-navy-900/90 border-2 border-gold/30 rounded-lg px-4 py-2 hover:border-gold hover:bg-navy-800/90 transition-all duration-300 shadow-lg hover:shadow-gold/50 group"
          >
            <FaTelegram className="w-5 h-5 text-gold group-hover:scale-110 transition-transform" />
            <span className="text-sm text-white/80 group-hover:text-gold transition-colors whitespace-nowrap">Telegram</span>
          </a>
          <a
            href="https://t.me/SaguexMarketing"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-navy-900/90 border-2 border-gold/30 rounded-lg px-4 py-2 hover:border-gold hover:bg-navy-800/90 transition-all duration-300 shadow-lg hover:shadow-gold/50 group"
          >
            <FaTelegram className="w-5 h-5 text-gold group-hover:scale-110 transition-transform" />
            <span className="text-sm text-white/80 group-hover:text-gold transition-colors whitespace-nowrap">Reklam Ver</span>
          </a>
        </div>

      {/* Sponsor Banner Cards Section */}
      {sponsorBanners.length > 0 && (
        <div className="max-w-7xl mx-auto mb-8 sm:mb-12 px-2 sm:px-0">
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
            {sponsorBanners.map((banner) => {
              // Convert banner to sponsor format for SponsorCard component
              const sponsorData = {
                id: banner.id,
                name: banner.name,
                description: banner.description || '',
                description_color: banner.description_color || banner.descriptionColor || '#fbbf24',
                button1_text: banner.button1_text || banner.button1Text || '',
                button1_link: banner.button1_link || banner.button1Link || '',
                link: banner.link,
                logo_url: banner.imageUrl || banner.image_url,
                tier: 'premium-sponsor',
                is_ad_card: true
              };
              return (
                <div 
                  key={banner.id} 
                  className="w-full max-w-5xl cursor-pointer touch-manipulation active:scale-[0.98] transition-transform"
                  onClick={() => {
                    if (banner.link) {
                      if (banner.link.startsWith('http://') || banner.link.startsWith('https://')) {
                        window.open(banner.link, '_blank', 'noopener,noreferrer');
                      } else {
                        window.location.href = banner.link;
                      }
                    } else if (banner.button1_link || banner.button1Link) {
                      const btnLink = banner.button1_link || banner.button1Link;
                      if (btnLink.startsWith('http://') || btnLink.startsWith('https://')) {
                        window.open(btnLink, '_blank', 'noopener,noreferrer');
                      } else {
                        window.location.href = btnLink;
                      }
                    }
                  }}
                >
                  <SponsorCard sponsor={sponsorData} isBanner={true} />
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Grid Sponsors Section */}
      {gridSponsors.length > 0 && (
        <div className="max-w-7xl mx-auto px-2 sm:px-0">
          {sections.map((section) => {
            const sectionSponsors = gridSponsors.filter(s => 
              (s.section_id || 'uncategorized') === section.id
            );
            
            if (sectionSponsors.length === 0) return null;

            // Group sponsors by size
            const heroSponsors = sectionSponsors.filter(s => s.size === 'hero');
            const largeSponsors = sectionSponsors.filter(s => s.size === 'large');
            const mediumSponsors = sectionSponsors.filter(s => s.size === 'medium' || (!s.size && s.tier !== 'ana-sponsor'));
            const smallSponsors = sectionSponsors.filter(s => s.size === 'small');

            return (
              <section key={section.id} className="mb-8 sm:mb-12">
                {sections.length > 1 && (
                  <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-center text-gold mb-4 sm:mb-6 drop-shadow-[0_0_15px_rgba(212,175,55,0.4)] px-2">
                    {section.title}
                  </h2>
                )}
                
                {section.description && (
                  <p className="text-center text-white/80 mb-4 sm:mb-6 max-w-2xl mx-auto text-sm sm:text-base px-2">
                    {section.description}
                  </p>
                )}

                {/* Hero Sponsors - 2 büyük kart birleşimi gibi */}
                {heroSponsors.length > 0 && (
                  <div className="mb-6 sm:mb-8">
                    <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
                      {heroSponsors.map((sponsor) => (
                        <div key={sponsor.id} className="w-full lg:w-[calc(50%-1rem)] max-w-[600px]">
                          <SponsorCard sponsor={sponsor} isBanner={false} />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Large Sponsors - 2 per row */}
                {largeSponsors.length > 0 && (
                  <div className="mb-6 sm:mb-8">
                    <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
                      {largeSponsors.map((sponsor) => (
                        <div key={sponsor.id} className="w-full lg:w-[calc(50%-1rem)] max-w-[600px]">
                          <SponsorCard sponsor={sponsor} isBanner={false} />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Medium Sponsors - 4 per row */}
                {mediumSponsors.length > 0 && (
                  <div className="mb-6 sm:mb-8">
                    <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
                      {mediumSponsors.map((sponsor) => (
                        <div key={sponsor.id} className="w-[calc(50%-0.5rem)] lg:w-[calc(25%-0.75rem)] max-w-[300px]">
                          <SponsorCard sponsor={sponsor} isBanner={false} />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Small Sponsors - 4 per row */}
                {smallSponsors.length > 0 && (
                  <div className="mb-6 sm:mb-8">
                    <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
                      {smallSponsors.map((sponsor) => (
                        <div key={sponsor.id} className="w-[calc(50%-0.25rem)] lg:w-[calc(25%-0.5rem)] max-w-[250px]">
                          <SponsorCard sponsor={sponsor} isBanner={false} />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </section>
            );
          })}

          {/* Uncategorized sponsors */}
          {(() => {
            const uncategorized = gridSponsors.filter(s => !s.section_id);
            if (uncategorized.length === 0) return null;

            const heroUncat = uncategorized.filter(s => s.size === 'hero');
            const largeUncat = uncategorized.filter(s => s.size === 'large');
            const mediumUncat = uncategorized.filter(s => s.size === 'medium' || (!s.size && s.tier !== 'ana-sponsor'));
            const smallUncat = uncategorized.filter(s => s.size === 'small');

            return (
              <section className="mb-8 sm:mb-12">
                {/* Hero */}
                {heroUncat.length > 0 && (
                  <div className="mb-6 sm:mb-8">
                    <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
                      {heroUncat.map((sponsor) => (
                        <div key={sponsor.id} className="w-full lg:w-[calc(50%-1rem)] max-w-[600px]">
                          <SponsorCard sponsor={sponsor} isBanner={false} />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Large */}
                {largeUncat.length > 0 && (
                  <div className="mb-6 sm:mb-8">
                    <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
                      {largeUncat.map((sponsor) => (
                        <div key={sponsor.id} className="w-full lg:w-[calc(50%-1rem)] max-w-[600px]">
                          <SponsorCard sponsor={sponsor} isBanner={false} />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Medium */}
                {mediumUncat.length > 0 && (
                  <div className="mb-6 sm:mb-8">
                    <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
                      {mediumUncat.map((sponsor) => (
                        <div key={sponsor.id} className="w-[calc(50%-0.5rem)] lg:w-[calc(25%-0.75rem)] max-w-[300px]">
                          <SponsorCard sponsor={sponsor} isBanner={false} />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Small */}
                {smallUncat.length > 0 && (
                  <div className="mb-6 sm:mb-8">
                    <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
                      {smallUncat.map((sponsor) => (
                        <div key={sponsor.id} className="w-[calc(50%-0.25rem)] lg:w-[calc(25%-0.5rem)] max-w-[250px]">
                          <SponsorCard sponsor={sponsor} isBanner={false} />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </section>
            );
          })()}
        </div>
      )}

        {/* Empty State */}
        {sponsorBanners.length === 0 && gridSponsors.length === 0 && (
          <div className="text-center text-white/60 py-20">
            <p className="text-xl">Henüz sponsor eklenmedi</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SponsorsPage;
